import {
  categoricalChartTooltipVariantOptions,
  CategoricalChartTooltipVariant,
} from '../types/categorical-bar-chart.js';

/**
 * Returns true if tooltipVariant is a valid CategoricalChartTooltipVariant
 * @param tooltipVariant - tooltip variant
 */
export const isValidTooltipVariant = (
  tooltipVariant: 'single' | 'grouped',
): tooltipVariant is CategoricalChartTooltipVariant =>
  categoricalChartTooltipVariantOptions.includes(tooltipVariant);
